



































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";
import postalCodeApi from "@/api/postalCodeApi";
import Location from "@/model/location";
import RepairContent from "@/model/repairContent";
import qNotify from "@/common/qNotify";
import Company from "@/model/company";
import { namespace } from "vuex-class";
import User, { USER_ROLE } from "@/model/user";
import repairContentApi from "@/api/repairContentApi";
import PaginateModel from "@/model/paginate";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import RepairContentDetail from "@/components/repair-content/repairContentDetail.vue";
import RepairContentEdit from "@/components/repair-content/repairContentEdit.vue";
import QCalendar from "@/common/qCalendar.vue";
import QWitnessSelect from "@/common/qWitnessSelect.vue";
import QUserSelect from "@/common/qUserSelect.vue";

const auth = namespace("Auth");
@Component({
  name: "RepairContentList",
  components: {
    QPaginate,
    QTableHeader,
    RepairContentDetail,
    RepairContentEdit,
    QCalendar,
    QWitnessSelect,
    QUserSelect,
  },
})
export default class RepairContentList extends Vue {
  @Prop()
  propertyId;
  @Prop()
  floorAreaId;
  @Prop({ default: "history" })
  mode: string;

  @auth.Getter
  getCurrentyCompany!: Company;
  @auth.Getter
  getUserLogging!: User;

  public search = {
    area_ids: [],
    property_id: "",
    sort: "repair_date",
    direction: "desc",
    page: 1,
    prefecture: "",
    area: "",
    repair_from_date: "",
    repair_to_date: "",
    property_name: "",
    witness_id: "",
    created_by: "",
  };
  public dateConfig = {};
  public headers = [
    { id: "repair_date", name: "日付", order: "desc" },
    { id: "", name: "物件名" },
    { id: "", name: "修繕箇所" },
    { id: "", name: "内容" },
    { id: "", name: "償却残日数" },
    { id: "", name: "備考" },
    { id: "", name: "修繕会社" },
    { id: "", name: "登録担当者" },
    { id: "", name: "" },
  ];
  public postalCode: Location[] = [];
  public userRole = USER_ROLE;
  public listRepairContent: RepairContent[] = null;
  public pagination = new PaginateModel({
    page: 1,
    pageCount: 1,
    start: 1,
    end: 1,
    count: 1,
  });

  constructor() {
    super();
  }
  mounted() {
    if (this.propertyId && this.mode === "history") {
      this.search.property_id = this.propertyId;
      this.getRepairContentList();
    } else if (this.mode != "history") {
      this.initalSearch(null);
      this.listPostalCode();
      this.getRepairContentList();
    }
  }

  public async getRepairContentList(query = {}) {
    const queryParameters = {...this.search, ...query};
    const result = await repairContentApi.index(queryParameters);
    this.pagination = result.paginate;
    this.listRepairContent = result.list;
  }

  get companyId() {
    return this.getCurrentyCompany ?  this.getCurrentyCompany.id : null;
  }

  get getArea() {
    this.search.prefecture;
    if (!this.search.prefecture) {
      return [];
    }
    const area = _.chain(this.postalCode)
      .filter((item) => item.prefecture === this.search.prefecture.trim())
      .uniqBy("area")
      .value();
    return area;
  }
  get getPrefecture() {
    return _.uniqBy(this.postalCode, "prefecture");
  }
  get getPaginate() {
    return this.pagination;
  }

  public async listPostalCode() {
    this.postalCode = await postalCodeApi.listOfProperty();
  }

  public doSearch() {
    // console.log(parameters);
    this.search.page = 1;
    this.changeState();
    this.getRepairContentList();
  }

  public changeState(): void {
    let { name, params, query }: any = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public addNew() {
    const repair = new RepairContent();
    // repair.floor_plan = this.propertyObject.floor_plan;
    // repair.property = this.propertyObject;
    (this.$refs.repairContentEditPopup as RepairContentEdit).show(
      repair,
      "from-repair-list"
    );
  }

  public duplicate(repairContent: RepairContent) {
    repairContent.id = null;
    (this.$refs.repairContentEditPopup as RepairContentEdit).show(
      repairContent,
      "from-repair-list",
      [],
      true
    );
  }

  public cancel() {
    this.search = {
      area_ids: [],
      property_id: "",
      sort: "repair_date",
      direction: "desc",
      page: 1,
      prefecture: "",
      area: "",
      repair_from_date: "",
      repair_to_date: "",
      property_name: "",
      witness_id: "",
      created_by: "",
    };
    this.search.created_by = this.getUserLogging ? this.getUserLogging.id : "";
    this.changeState();
    this.getRepairContentList();
  }

  public onAddNew() {
    qNotify.success({
      text: this.$t("repairContents.created"),
    });
    this.getRepairContentList();
  }
  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    this.search = {
      ...{
        area_ids: [],
        property_id: "",
        sort: "repair_date",
        direction: "desc",
        page: 1,
        prefecture: "",
        area: "",
        repair_from_date: "",
        repair_to_date: "",
        property_name: "",
        witness_id: "",
        created_by: "",
      },
      ...query,
    };
    this.search.created_by = this.getUserLogging ? this.getUserLogging.id : "";
    // console.log(this.search);
  }
  public doPaginate(parameters) {
    parameters.page && (this.search.page = parameters.page);
    parameters.sort && (this.search.sort = parameters.sort);
    parameters.direction && (this.search.direction = parameters.direction);
    this.getRepairContentList();
  }

  @Watch("propertyId", { deep: true })
  changePropProperty(newValue) {
    this.search.property_id = newValue;
    this.getRepairContentList();
  }

  public viewDetail(repairDetail: RepairContent, mode: "exists-property") {
    // case latest
    if (this.$ability.can("edit", "PropertyRepairContent")) {
      if (repairDetail.is_latest) {
        (this.$refs.repairContentEditPopup as RepairContentEdit).showById(
          repairDetail,
          mode
        );
      } else {
        (this.$refs.repairContentDetailPopup as RepairContentDetail).show(
          repairDetail,
          mode
        );
      }
    } else {
      (this.$refs.repairContentDetailPopup as RepairContentDetail).show(
        repairDetail,
        mode
      );
    }
  }
}
